import styled from 'styled-components';

import FormItemWrapper from './FormItemWrapper';
import { commonStyles, errorStyles } from './styles';

const Input = styled.input`
  height: 46px;
  ${commonStyles}
  ${({ hasError }) => (hasError ? errorStyles : '')}
`;

const Textarea = styled.textarea`
  ${commonStyles}
  ${({ hasError }) => (hasError ? errorStyles : '')}
  padding-top: 14px;
  padding-bottom: 14px;
`;

const Select = styled.select`
  height: 46px;
  ${commonStyles}
  cursor: pointer;
  ${({ hasError }) => (hasError ? errorStyles : '')}
`;

// CheckBox and Radio styles

const CheckBox = styled.input`
  margin: 0;
  appearance: none;
  display: none;
`;

const Radio = styled.input`
  margin: 0;
  appearance: none;
  display: none;
`;

const ToggleFormItemWrapper = styled.label`
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  min-height: 22px;
  cursor: pointer;
  user-select: none;
`;

const ToggleFormItemLabel = styled.span`
  margin-left: 10px;
`;

const CheckBoxWrapper = styled(ToggleFormItemWrapper)`
  span[data-type='checkbox'] {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    border-color: var(--gray-base);
    box-shadow: 0px 1px 3px rgba(153, 155, 162, 0.2);
    border-radius: 3px;
    padding: 3px;
    svg {
      opacity: 0;
      visibility: hidden;
      path {
        fill: white;
      }
    }
  }
  input:checked + {
    span[data-type='checkbox'] {
      background: linear-gradient(#3eaaf0, #057fce);
      border-color: var(--blue-light);
      svg {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  input:focus + {
    span[data-type='checkbox'] {
      box-shadow: 0 0 0 3px rgb(230, 244, 250);
    }
  }
  &:hover {
    span[data-type='checkbox'] {
      border-color: var(--teal-dark);
    }
  }
`;

const CheckBoxLabel = styled(ToggleFormItemLabel)``;

const RadioWrapper = styled(ToggleFormItemWrapper)`
  span[data-type='radio'] {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    justify-content: center;
    border: 1px solid;
    border-color: var(--gray-base);
    box-shadow: 0px 1px 3px rgba(153, 155, 162, 0.2);
  }
  input:checked + {
    span[data-type='radio'] {
      border-color: var(--blue-light);
      &:after {
        content: '';
        background: linear-gradient(#3eaaf0, #057fce);
        border-radius: 50%;
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
    }
  }
  input:focus + {
    span[data-type='radio'] {
      box-shadow: 0 0 0 3px rgb(230, 244, 250);
    }
  }
  &:hover {
    span[data-type='radio'] {
      border-color: var(--teal-dark);
    }
  }
`;

const RadioLabel = styled(ToggleFormItemLabel)``;

// exports
export {
  FormItemWrapper,
  Input,
  Textarea,
  Select,
  CheckBoxWrapper,
  CheckBoxLabel,
  CheckBox,
  RadioWrapper,
  RadioLabel,
  Radio
};
